export const RegionsOption = [
  // {
  //   label: "East",
  //   text: "East",
  //   value: 1,
  // },
  {
    label: "LONDON",
    text: "LONDON",
    value: 3,
  },
  {
    label: "MIDLANDS",
    text: "MIDLANDS",
    value: 2,
  },
  {
    label: "NORTH EAST Y&H",
    text: "NORTH EAST Y&H",
    value: 4,
  },
  {
    label: "NORTH WEST",
    text: "NORTH WEST",
    value: 5,
  },
  // {
  //   label: "REMOTE",
  //   text: "REMOTE",
  //   value: 6,
  // },
  {
    label: "SOUTH EAST & EAST",
    text: "SOUTH EAST & EAST",
    value: 7,
  },
  {
    label: "SOUTH WEST & SOUTH CENTRAL",
    text: "SOUTH WEST & SOUTH CENTRAL",
    value: 8,
  },
  {
    label: "WALES",
    text: "WALES",
    value: 9,
  },
  // {
  //   label: "YORKSHIRE AND THE HUMBER",
  //   text: "YORKSHIRE AND THE HUMBER",
  //   value: 11,
  // },
];

export const PrisonsOption = [
  // { label: "ALL PRISONS", text: "ALL PRISONS", value: -1 },
  { label: "ALTCOURSE", text: "ALTCOURSE", value: 1 },
  { label: "ASHFIELD", text: "ASHFIELD", value: 2 },
  { label: "ASKHAM GRANGE (YOI)", text: "ASKHAM GRANGE (YOI)", value: 3 },
  { label: "AYLESBURY", text: "AYLESBURY", value: 4 },
  { label: "BEDFORD", text: "BEDFORD", value: 5 },
  { label: "BELMARSH", text: "BELMARSH", value: 6 },
  { label: "BERWYN", text: "BERWYN", value: 7 },
  { label: "BIRMINGHAM", text: "BIRMINGHAM", value: 8 },
  { label: "BRINSFORD", text: "BRINSFORD", value: 9 },
  { label: "BRISTOL", text: "BRISTOL", value: 10 },
  { label: "BRIXTON", text: "BRIXTON", value: 11 },
  { label: "BRONZEFIELD", text: "BRONZEFIELD", value: 12 },
  { label: "BUCKLEY HALL", text: "BUCKLEY HALL", value: 13 },
  { label: "BULLINGDON", text: "BULLINGDON", value: 14 },
  { label: "BURE", text: "BURE", value: 15 },
  { label: "CARDIFF", text: "CARDIFF", value: 16 },
  { label: "CHANNINGS WOOD", text: "CHANNINGS WOOD", value: 17 },
  { label: "CHELMSFORD", text: "CHELMSFORD", value: 18 },
  { label: "COLDINGLEY", text: "COLDINGLEY", value: 19 },
  { label: "COOKHAM WOOD (YOI)", text: "COOKHAM WOOD (YOI)", value: 20 },
  { label: "DARTMOOR", text: "DARTMOOR", value: 21 },
  { label: "DEERBOLT", text: "DEERBOLT", value: 22 },
  { label: "DONCASTER", text: "DONCASTER", value: 23 },
  { label: "DOVEGATE", text: "DOVEGATE", value: 24 },
  { label: "DOWNVIEW (YOI)", text: "DOWNVIEW (YOI)", value: 25 },
  { label: "DRAKE HALL (YOI)", text: "DRAKE HALL (YOI)", value: 26 },
  { label: "DURHAM", text: "DURHAM", value: 27 },
  {
    label: "EAST SUTTON PARK (YOI)",
    text: "EAST SUTTON PARK (YOI)",
    value: 28,
  },
  { label: "EASTWOOD PARK (YOI)", text: "EASTWOOD PARK (YOI)", value: 29 },
  { label: "ELMLEY", text: "ELMLEY", value: 30 },
  { label: "ERLESTOKE", text: "ERLESTOKE", value: 31 },
  { label: "EVERTHORPE", text: "EVERTHORPE", value: 32 },
  { label: "EXETER", text: "EXETER", value: 33 },
  { label: "FEATHERSTONE", text: "FEATHERSTONE", value: 34 },
  { label: "FELTHAM (YOI)", text: "FELTHAM (YOI)", value: 35 },
  { label: "FIVE WELLS", text: "FIVE WELLS", value: 36 },
  { label: "FORD", text: "FORD", value: 37 },
  { label: "FOREST BANK", text: "FOREST BANK", value: 38 },
  { label: "FOSSE WAY", text: "FOSSE WAY", value: 39 },
  { label: "FOSTON HALL (YOI)", text: "FOSTON HALL (YOI)", value: 40 },
  { label: "FRANKLAND", text: "FRANKLAND", value: 41 },
  { label: "FULL SUTTON", text: "FULL SUTTON", value: 42 },
  { label: "GARTH", text: "GARTH", value: 43 },
  { label: "GARTREE", text: "GARTREE", value: 44 },
  { label: "GRENDON", text: "GRENDON", value: 45 },
  { label: "GUYS MARSH", text: "GUYS MARSH", value: 46 },
  { label: "HATFIELD", text: "HATFIELD", value: 47 },
  { label: "HAVERIGG", text: "HAVERIGG", value: 48 },
  { label: "HEWELL", text: "HEWELL", value: 49 },
  { label: "HIGH DOWN", text: "HIGH DOWN", value: 50 },
  { label: "HIGH POINT", text: "HIGH POINT", value: 51 },
  { label: "HINDLEY", text: "HINDLEY", value: 52 },
  { label: "HOLLESLEY BAY", text: "HOLLESLEY BAY", value: 53 },
  { label: "HOLME HOUSE", text: "HOLME HOUSE", value: 54 },
  { label: "HULL", text: "HULL", value: 55 },
  { label: "HUMBER", text: "HUMBER", value: 56 },
  { label: "HUNTERCOMBE", text: "HUNTERCOMBE", value: 57 },
  { label: "ISIS", text: "ISIS", value: 58 },
  { label: "ISLE OF WIGHT", text: "ISLE OF WIGHT", value: 59 },
  { label: "KIRKHAM", text: "KIRKHAM", value: 60 },
  { label: "KIRKLEVINGTON GRANGE", text: "KIRKLEVINGTON GRANGE", value: 61 },
  { label: "LANCASTER FARMS", text: "LANCASTER FARMS", value: 62 },
  { label: "LEEDS", text: "LEEDS", value: 63 },
  { label: "LEICESTER", text: "LEICESTER", value: 64 },
  { label: "LEWES", text: "LEWES", value: 65 },
  { label: "LEYHILL", text: "LEYHILL", value: 66 },
  { label: "LINCOLN", text: "LINCOLN", value: 67 },
  { label: "LINDHOLME", text: "LINDHOLME", value: 68 },
  { label: "LITTLEHEY", text: "LITTLEHEY", value: 69 },
  { label: "LIVERPOOL", text: "LIVERPOOL", value: 70 },
  { label: "LONG LARTIN", text: "LONG LARTIN", value: 71 },
  { label: "LOW NEWTON (YOI)", text: "LOW NEWTON (YOI)", value: 124 },
  { label: "LOWDHAM GRANGE", text: "LOWDHAM GRANGE", value: 123 },
  { label: "MAIDSTONE", text: "MAIDSTONE", value: 73 },
  { label: "MANCHESTER", text: "MANCHESTER", value: 74 },
  { label: "MOORLAND", text: "MOORLAND", value: 75 },
  { label: "MORTON HALL", text: "MORTON HALL", value: 76 },
  { label: "NEW HALL (YOI)", text: "NEW HALL (YOI)", value: 77 },
  { label: "NORTH SEA CAMP", text: "NORTH SEA CAMP", value: 78 },
  { label: "NORTHUMBERLAND", text: "NORTHUMBERLAND", value: 79 },
  { label: "NORWICH", text: "NORWICH", value: 80 },
  { label: "NOTTINGHAM", text: "NOTTINGHAM", value: 81 },
  { label: "OAKWOOD", text: "OAKWOOD", value: 82 },
  { label: "ONLEY", text: "ONLEY", value: 83 },
  { label: "PARC (YOI)", text: "PARC (YOI)", value: 84 },
  { label: "PENTONVILLE", text: "PENTONVILLE", value: 85 },
  { label: "PETERBOROUGH", text: "PETERBOROUGH", value: 86 },
  { label: "PORTLAND (YOI)", text: "PORTLAND (YOI)", value: 87 },
  { label: "PRESCOED", text: "PRESCOED", value: 88 },
  { label: "PRESTON", text: "PRESTON", value: 89 },
  { label: "RANBY", text: "RANBY", value: 90 },
  { label: "RISLEY", text: "RISLEY", value: 91 },
  { label: "ROCHESTER", text: "ROCHESTER", value: 92 },
  { label: "RYE HILL", text: "RYE HILL", value: 93 },
  { label: "SEND", text: "SEND", value: 94 },
  { label: "SPRING HILL", text: "SPRING HILL", value: 95 },
  { label: "STAFFORD", text: "STAFFORD", value: 96 },
  { label: "STANDFORD HILL", text: "STANDFORD HILL", value: 97 },
  { label: "STOCKEN", text: "STOCKEN", value: 98 },
  { label: "STOKE HEATH", text: "STOKE HEATH", value: 99 },
  { label: "STYAL (YOI)", text: "STYAL (YOI)", value: 100 },
  { label: "SUDBURY", text: "SUDBURY", value: 101 },
  { label: "SWALESIDE", text: "SWALESIDE", value: 102 },
  { label: "SWANSEA", text: "SWANSEA", value: 103 },
  { label: "SWINFEN HALL", text: "SWINFEN HALL", value: 104 },
  { label: "THAMESIDE", text: "THAMESIDE", value: 105 },
  { label: "THE MOUNT", text: "THE MOUNT", value: 106 },
  { label: "THE VERNE", text: "THE VERNE", value: 107 },
  { label: "THORN CROSS", text: "THORN CROSS", value: 108 },
  { label: "USK", text: "USK", value: 109 },
  { label: "WAKEFIELD", text: "WAKEFIELD", value: 110 },
  { label: "WANDSWORTH", text: "WANDSWORTH", value: 111 },
  { label: "WARREN HILL", text: "WARREN HILL", value: 112 },
  { label: "WAYLAND", text: "WAYLAND", value: 113 },
  { label: "WEALSTUN", text: "WEALSTUN", value: 114 },
  { label: "WERRINGTON (YOI)", text: "WERRINGTON (YOI)", value: 115 },
  { label: "WETHERBY (YOI)", text: "WETHERBY (YOI)", value: 116 },
  { label: "WHATTON", text: "WHATTON", value: 117 },
  { label: "WHITEMOOR", text: "WHITEMOOR", value: 118 },
  { label: "WINCHESTER", text: "WINCHESTER", value: 119 },
  { label: "WOLDS", text: "WOLDS", value: 126 },
  { label: "WOODHILL", text: "WOODHILL", value: 120 },
  { label: "WORMWOOD SCRUBS", text: "WORMWOOD SCRUBS", value: 121 },
  { label: "WYMOTT", text: "WYMOTT", value: 122 },
];

export const ProbationRegionsOption = [
  {
    label: "EAST MIDLANDS",
    text: "EAST MIDLANDS",
    value: 1,
  },
  {
    label: "EAST OF ENGLAND",
    text: "EAST OF ENGLAND",
    value: 2,
  },
  {
    label: "GREATER MANCHESTER",
    text: "GREATER MANCHESTER",
    value: 3,
  },
  {
    label: "KENT SURREY & SUSSEX",
    text: "KENT SURREY & SUSSEX",
    value: 4,
  },
  {
    label: "LONDON",
    text: "LONDON",
    value: 5,
  },
  {
    label: "NORTH EAST",
    text: "NORTH EAST",
    value: 6,
  },
  {
    label: "NORTH WEST",
    text: "NORTH WEST",
    value: 7,
  },
  {
    label: "SOUTH CENTRAL",
    text: "SOUTH CENTRAL",
    value: 8,
  },
  {
    label: "SOUTH EAST",
    text: "SOUTH EAST",
    value: 13,
  },
  {
    label: "SOUTH WEST",
    text: "SOUTH WEST",
    value: 9,
  },
  {
    label: "WALES",
    text: "WALES",
    value: 10,
  },
  {
    label: "WEST MIDLANDS",
    text: "WEST MIDLANDS",
    value: 11,
  },
  {
    label: "YORKSHIRE AND THE HUMBER",
    text: "YORKSHIRE AND THE HUMBER",
    value: 12,
  },
];

export const AreaCoveredOption = [
  {
    label: "1 OR MORE LOCAL AUTHORITIES",
    text: "1 OR MORE LOCAL AUTHORITIES",
    value: 1,
  },
  {
    label: "1 OR MORE REGIONS",
    text: "1 OR MORE REGIONS",
    value: 2,
  },
  {
    label: "ENGLAND",
    text: "ENGLAND",
    value: 6,
  },
  {
    label: "ENGLAND & WALES",
    text: "ENGLAND & WALES",
    value: 5,
  },
  {
    label: "LOCAL OR NEIGHBOURHOOD",
    text: "LOCAL OR NEIGHBOURHOOD",
    value: 3,
  },
  // {
  //   label: "NATIONAL",
  //   text: "NATIONAL",
  //   value: 4,
  // },
  {
    label: "WALES",
    text: "WALES",
    value: 7,
  },
];

export const TypeOfOrganisationOption = [
  {
    label: "ACADEMIC",
    text: "ACADEMIC",
    value: 4,
  },
  {
    label: "CROSS-SECTOR PARTNERSHIP OR CONSORTIUM",
    text: "CROSS-SECTOR PARTNERSHIP OR CONSORTIUM",
    value: 5,
  },
  {
    label: "FUNDER",
    text: "FUNDER",
    value: 7,
  },
  {
    label: "INDIVIDUAL",
    text: "INDIVIDUAL",
    value: 6,
  },
  {
    label: "PRIVATE SECTOR",
    text: "PRIVATE SECTOR",
    value: 3,
  },
  {
    label: "PUBLIC SECTOR",
    text: "PUBLIC SECTOR",
    value: 2,
  },
  {
    label: "VOLUNTARY AND COMMUNITY SECTOR",
    text: "VOLUNTARY AND COMMUNITY SECTOR",
    value: 1,
  },
];

export const CustodyOrCommunityOption = [
  {
    label: "COMMUNITY",
    text: "COMMUNITY",
    value: 1,
  },
  {
    label: "CUSTODY",
    text: "CUSTODY",
    value: 2,
  },
];

export const RaciallyMinoritisedOption = [
  {
    label: "ANY OTHER",
    text: "ANY OTHER",
    value: 21,
  },
  {
    label: "ARAB",
    text: "ARAB",
    value: 9,
  },
  {
    label: "ASIAN OTHER",
    text: "ASIAN OTHER",
    value: 7,
  },
  {
    label: "BANGLADESHI",
    text: "BANGLADESHI",
    value: 6,
  },
  {
    label: "BLACK AFRICAN",
    text: "BLACK AFRICAN",
    value: 2,
  },
  {
    label: "BLACK BRITISH",
    text: "BLACK BRITISH",
    value: 1,
  },
  {
    label: "BLACK CARIBBEAN",
    text: "BLACK CARIBBEAN",
    value: 3,
  },
  {
    label: "BLACK OTHER",
    text: "BLACK OTHER",
    value: 16,
  },
  {
    label: "CHINESE",
    text: "CHINESE",
    value: 11,
  },
  {
    label: "DUAL HERITAGE",
    text: "DUAL HERITAGE",
    value: 8,
  },
  {
    label: "FOREIGN NATIONALS",
    text: "FOREIGN NATIONALS",
    value: 13,
  },
  {
    label: "GYPSY OR IRISH TRAVELLER",
    text: "GYPSY OR IRISH TRAVELLER",
    value: 12,
  },
  {
    label: "INDIAN",
    text: "INDIAN",
    value: 4,
  },
  {
    label: "IRISH",
    text: "IRISH",
    value: 10,
  },
  {
    label: "MIXED AFRICAN",
    text: "MIXED AFRICAN",
    value: 17,
  },
  {
    label: "MIXED ASIAN",
    text: "MIXED ASIAN",
    value: 19,
  },
  {
    label: "MIXED CARIBBEAN",
    text: "MIXED CARIBBEAN",
    value: 18,
  },
  {
    label: "MIXED OTHER",
    text: "MIXED OTHER",
    value: 20,
  },
  {
    label: "OTHER",
    text: "OTHER",
    value: 15,
  },
  {
    label: "PAKISTANI",
    text: "PAKISTANI",
    value: 5,
  },
  {
    label: "ROMA",
    text: "ROMA",
    value: 14,
  },
  {
    label: "WHITE",
    text: "WHITE",
    value: 22,
  },
];

export const SpecialistOrganisationOption = [
  { label: "ARTS SPECIALIST", text: "ARTS SPECIALIST", value: 1 },
  { label: "FAMILIES’ SPECIALIST", text: "FAMILIES’ SPECIALIST", value: 2 },
  {
    label: "LIVED EXPERIENCE-LED ORGANISATION",
    text: "LIVED EXPERIENCE-LED ORGANISATION",
    value: 5,
  },
  {
    label: "OLDER PEOPLE SPECIALIST",
    text: "OLDER PEOPLE SPECIALIST",
    value: 3,
  },

  {
    label: "RACIALLY MINORITISED BY-AND-FOR ORGANISATION",
    text: "RACIALLY MINORITISED BY-AND-FOR ORGANISATION",
    value: 4,
  },

  { label: "WOMEN’S SPECIALIST", text: "WOMEN’S SPECIALIST", value: 6 },
];
